import { CountryCreatePage } from '@/features/geolocation/page/CountryCreatePage';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/geolocation/country/create')({
  component: CountryCreatePage,
})
